import React, { useEffect } from 'react'
import Button from './Button'
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { apiCallBegan } from '../store/api';
import { refreshURL } from '../store/slices/cache'
import { AiOutlineUser } from '@react-icons/all-files/ai/AiOutlineUser';
import { AiOutlineDollar } from '@react-icons/all-files/ai/AiOutlineDollar';
import { AiOutlineFullscreen } from '@react-icons/all-files/ai/AiOutlineFullscreen';
import { FaHashtag } from '@react-icons/all-files/fa/FaHashtag';
import Input from './Input';
import { helper } from '../utilities/helper';

const SQMetrics = ({ potential, setStep, metrics }) => {
  let dispatch = useDispatch()
  let { register, errors, setValue, handleSubmit } = useForm()
  console.log(metrics)

  let av ={'sound': 'Speakers & Microphones', 'visuals': 'Projectors, TVs and Video Walls', 'staging': 'Stages, Truss, Pipe & Drape', 'lighting': 'Stage Lighting, Uplights, Spotlights', 'dj': 'DJ Equipment', 'effects': 'Special Effects: CO2 Cannons, Cold Sparks...'}


  useEffect(() => {
    if (potential) {
      setValue('venue_size', potential?.metrics?.venue_size)
      setValue('events_week', potential?.metrics?.events_week)
      setValue('event_cost', potential?.metrics?.event_cost)
      setValue('av_cost', potential?.metrics?.av_cost)
      Object.keys(helper.eventTypes).forEach(et => {
        setValue(`event_types.${et}`, potential?.metrics?.event_types?.[et])
      })
      Object.keys(av).forEach(et => {
        setValue(`av_used.${et}`, potential?.metrics?.av_used?.[et])
      })
    }
  }, [potential])

  let submit = (data) => {
    dispatch(apiCallBegan({ url: `/business/edits/${potential?._id}`, method: 'PUT', data: {
      current_tier: 2,
      'metrics.venue_size': data.venue_size,
      'metrics.events_week': data.events_week,
      'metrics.event_cost': data.event_cost,
      'metrics.av_cost': data.av_cost,
      'metrics.event_types': data.event_types,
      'metrics.av_used': data.av_used,
    }, showSpinner: true, onSuccessFunc: () => refreshURL(`/business/withContacts/${potential?._id}`), onExtFunc: () => setStep(2) }))
  }

  return <div className='sSlide'>
    <form className='compCard' onSubmit={handleSubmit(submit)}>
      <h2 className='sqTitle'>Event Volume</h2>
      <div className="row">

          {potential?.business_type ==='venue' &&         <div className='col'>
          <strong>Venue Size:</strong>
        <div className={`inputIcon`}>
          <select id="venue_size" name="venue_size" placeholder='venue_size' ref={register} >
            <option value={null}>Select Venue Size</option>
            <option value={'small'}>{metrics[potential?.sub_type]?.small?.definition}</option>
            <option value={'medium'}>{metrics[potential?.sub_type]?.medium?.definition}</option>
            <option value={'large'}>{metrics[potential?.sub_type]?.large?.definition}</option>
          </select>
          <label id="venue_size" htmlFor='venue_size' ><AiOutlineFullscreen /></label>
        </div>
        </div>}


        <div className='col'>
        <strong>Number of Events per week:</strong>
        <div className={`inputIcon`}>
          <input id="events_week" name='events_week' placeholder='Number of events per week:' type='number' ref={register} />
          <label id="events_week" htmlFor='events_week' ><FaHashtag /></label>
        </div>
      </div>
      </div>

      <div className="row">
      <div className='col'>
      <strong>Average event cost including AV:</strong>
      <div className={`inputIcon`}>
          <input id="event_cost" name='event_cost' placeholder='Average event cost including AV:' type='number' ref={register} />
          <label id="event_cost" htmlFor='event_cost' ><AiOutlineDollar /></label>
        </div>
        </div>
        <div className='col'>
        <strong>Average cost of AV:</strong>
      <div className={`inputIcon`}>
          <input id="av_cost" name='av_cost' placeholder='Average cost of AV:' type='number' ref={register} />
          <label id="av_cost" htmlFor='av_cost' ><AiOutlineDollar /></label>
        </div>
        </div>
      </div>
      <h2 className='sqTitle'>Type of Events Serviced</h2>
      <div className="painRow">
            {Object.keys(helper.eventTypes).map((k,i) => <Input className='field-check-rev'  type='checkbox' _ref={register}  name={`event_types.${k}`} label={helper.eventTypes[k]} />)}
        </div>
        <h2 className='sqTitle'>Type of AV Equipment Used</h2>
      <div className="painRow">
            {Object.keys(av).map((k,i) => <Input className='field-check-rev'  type='checkbox' _ref={register}  name={`av_used.${k}`} label={av[k]} />)}
        </div>
      <div className="buttons">
      <Button className='btn-4 ' noButton onClick={() => setStep(0)} >Back</Button>
      <Button className='btn-4 highLight '>Continue</Button>
    </div>
    </form>


  </div>
}

export default SQMetrics